import { makeStyles } from '@material-ui/core/styles';

export const useHeroStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(5, 0),
    position: 'relative',
  },
  box: {
    width: '100%',
    margin: 'auto',
    position: 'relative',
  },
  main: {
    width: '100%',
    margin: 'auto',
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  mainImg: {
    width: '80%',
    height: 'auto',
    maxWidth: theme.breakpoints.values.md,
  },
  description: {
    padding: theme.spacing(0, 0.5),
    textAlign: 'center',
    '& p': {
      fontSize: theme.typography.pxToRem(14),
      paddingBottom: '1rem',
      '&:not(:last-child)': {
        paddingBottom: 0,
        [theme.breakpoints.up('sm')]: {
          paddingBottom: '1rem',
        },
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(16),
        lineHeight: 1.3,
      },
    },
  },
}));
